/**
 * IE | FIREFOX | Safari fix
 * returns the event’s path which is an array of the objects on which listeners will be invoked
 * @param e - MouseEvent
 * @returns {Array|EventTarget[]|*}
 */
function getEventPath(e) {
  if ('composedPath' in e) return e.composedPath();
  if ('path' in e) return e.path;
  // polyfill
  const path = [];
  let currentElem = e.target;
  while (currentElem) {
    path.push(currentElem);
    currentElem = currentElem.parentElement;
  }
  if (path.indexOf(window) === -1 && path.indexOf(document) === -1) path.push(document);
  if (path.indexOf(window) === -1) path.push(window);
  return path;
}

export default getEventPath;
